export const iconFontAwesomeConstructionRulerHorizontal = (
	<i className="fa-solid fa-ruler-horizontal"></i>
);
